import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SendMailContactService } from '../httpServices/send-mail-contact.service';
import { SignPromissoryNoteService } from '../httpServices/sign-promissory-note.service';
import { HttpClientAuthServiceService } from '../httpServices/http-client-auth-service.service';
import { AlertasService } from '../alerta_servicio/alertas.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css'],
})
export class ContactoComponent implements OnInit {
  id: string;
  sendMail: any[] = [];

  public nombre: any;
  public correo: any;
  public celular: any;
  public asunto: any;
  public mensaje: any;




  public lastId: string;
  public lastTypeId: string;
  public loading: boolean = false;
  public loading_page: boolean = false;
  public myImage: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    protected sendMailContactService: SendMailContactService,
    protected signPromissoryNoteService: SignPromissoryNoteService,
    protected httpService: HttpClientAuthServiceService,
    private alertas: AlertasService,
    private route: ActivatedRoute
  ) {}

  onSubmit(form: NgForm): void {
    console.log(this.correo);
    this.correo=null;
    setTimeout(()=>{
      window.location.reload();
    },2000);

  }

  onReset(form: NgForm): void {
    form.reset();
  }

  async ngOnInit(): Promise<void> {


    this.lastId = "0";
    this.lastTypeId = "0";

    function delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
  }

    await this.httpService.login();

    this.route.queryParams.subscribe(params =>{
      this.id = params['token'];
    });

    if(this.id != null)
    {
      this.loading_page = true;
      await delay(3000);
    }
  }

  form = {
    fullname: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false,
  };




  sendMailToContact() {
    if (
      this.nombre != null &&
      this.correo != null &&
      this.celular != null &&
      this.asunto != null &&
      this.mensaje
    ) {
      this.loading = true;
      this.loading_page = true;
      this.sendMailContactService
        .sendMail(
          this.nombre,
          this.correo,
          this.celular,
          this.asunto,
          this.mensaje
        )
        .subscribe(
          (data) => {
            this.loading = false;
            this.loading_page = false;
            this.sendMail = data.body['message'];
            console.log('datp ' + this.sendMail);
            this.alertas.showSuccess(
              'Solicitud de contacto enviada exitosamente',
              'Información'
            );
            this.nombre = null;
            this.correo = null;
            this.celular = null;
            this.asunto = null;
            this.mensaje = null;
            setTimeout(()=>{
              window.location.reload();
            },2000);
          },
          (error) => {
            this.alertas.showError(
              error.error['message'],
              'Error enviando la solicitud de contacto'
            );
            this.loading = false;
            this.loading_page = false;
          }
        );
    } else {
      this.alertas.showError(
        'Todos los campos son obligatorios',
        'Campos Obligatorios'
      );
    }
  }
}
